import { Typography } from '@neo4j-ndl/react';

import { useGraphVizContext } from '../graph-viz-context';
import { GraphVizSidepanel } from '../graph-viz-sidepanel';
import { GraphChip } from './graph-chip';
import { ShowAll } from './show-all';

const OVERVIEW_STEP_SIZE = 25;

export function OverviewPanel(): JSX.Element {
  const { nvlGraph } = useGraphVizContext();

  return (
    <>
      <GraphVizSidepanel.Title>
        <Typography variant="h6">Results overview</Typography>
      </GraphVizSidepanel.Title>
      <GraphVizSidepanel.Content>
        <div className="mx-4 flex flex-col gap-2">
          {nvlGraph.dataLookupTable.labels.length > 0 && (
            <div className="flex flex-col gap-2">
              <div className={`flex items-center justify-between text-sm`}>
                <span>Nodes{` (${nvlGraph.nodes.length.toLocaleString()})`}</span>
              </div>

              <div className="flex flex-row flex-wrap gap-x-1.5 gap-y-1 leading-tight">
                <ShowAll initiallyShown={OVERVIEW_STEP_SIZE} isButtonGroup>
                  {nvlGraph.dataLookupTable.labels.map(
                    (label) =>
                      function GraphChipWrapper() {
                        return (
                          <GraphChip
                            type="node"
                            key={label}
                            label={label}
                            count={nvlGraph.dataLookupTable.labelMetaData[label]?.totalCount ?? 0}
                            tabIndex={-1}
                            color={nvlGraph.dataLookupTable.labelMetaData[label]?.mostCommonColor ?? ''}
                          />
                        );
                      },
                  )}
                </ShowAll>
              </div>
            </div>
          )}

          {nvlGraph.dataLookupTable.types.length > 0 && (
            <div className="flex flex-col gap-2">
              <span className="text-sm">Relationships{` (${nvlGraph.rels.length.toLocaleString()})`}</span>
              <div className="flex flex-row flex-wrap gap-x-1.5 gap-y-1 leading-tight">
                <ShowAll initiallyShown={OVERVIEW_STEP_SIZE} isButtonGroup>
                  {nvlGraph.dataLookupTable.types.map((type) => (
                    <GraphChip
                      type="relationship"
                      key={type}
                      label={type}
                      count={nvlGraph.dataLookupTable.typeMetaData[type]?.totalCount ?? 0}
                      color={nvlGraph.dataLookupTable.typeMetaData[type]?.mostCommonColor ?? ''}
                    />
                  ))}
                </ShowAll>
              </div>
            </div>
          )}
        </div>
      </GraphVizSidepanel.Content>
    </>
  );
}
